/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PlatformTaskProperties {
    getFixupPrototypeFunction() { return PlatformTaskProperties.fixupPrototype; }

    static newInstance(model: Partial<PlatformTaskProperties>): PlatformTaskProperties {
        let obj = Object.assign(new PlatformTaskProperties(), model);
        PlatformTaskProperties.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PlatformTaskProperties>): PlatformTaskProperties {
        if (!model) return null;
        return PlatformTaskProperties.newInstance(<PlatformTaskProperties> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PlatformTaskProperties) {
        if (!obj) return;

        models.PlatformTaskProperties.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PlatformTaskProperties): boolean {
        Object.setPrototypeOf(obj, PlatformTaskProperties.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.days === undefined) {
            this.days = 0;
        }
    }

    /**
     * Number of days for backfill
     */
    days: number;

}
